export const SpaceTemplateAlertService = Symbol('SpaceTemplateAlertService');
